import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { getConnectedUsersDataApi } from './api';
import { GetConnectedUsersApiResponse } from './model';

export const WAHA_FEATURE_KEY = 'wahaData';

export interface CreateGroupDrawerState {
  open: boolean;
  drawer: 'new' | 'edit';
}

interface guestDetailsProps {
  id: string;
  mobile: string;
  name: string;
  inviteId: string;
}
interface TeamememberDrawerProps {
  open: boolean;
  type: 'new' | 'edit';
}

export interface WahaState {
  connectedWabaAccounts: GetConnectedUsersApiResponse[];
  drawer: CreateGroupDrawerState;
  guestDetails: guestDetailsProps;
  teamMemberDrawer: TeamememberDrawerProps;
}

export const initialWahaState: WahaState = {
  connectedWabaAccounts: [],
  drawer: {
    open: false,
    drawer: 'new',
  },
  teamMemberDrawer: {
    open: false,
    type: 'new',
  },
  guestDetails: {
    id: '',
    mobile: '',
    name: '',
    inviteId: '',
  },
};

export const wahaSlice = createSlice({
  name: WAHA_FEATURE_KEY,
  initialState: initialWahaState,
  reducers: {
    updateOpenDrawer(
      state,
      action: PayloadAction<Partial<CreateGroupDrawerState>>
    ) {
      state.drawer = { ...state.drawer, ...action.payload };
    },
    updateGuestDetails(
      state,
      action: PayloadAction<Partial<WahaState['guestDetails']>>
    ) {
      state.guestDetails = {
        ...state.guestDetails,
        ...action.payload,
      };
    },
    updateTeamMemberDrawer(
      state,
      action: PayloadAction<Partial<TeamememberDrawerProps>>
    ) {
      state.teamMemberDrawer = { ...state.teamMemberDrawer, ...action.payload };
    },

    clearConnectedWabaAccounts(state) {
      state.connectedWabaAccounts = [];
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      getConnectedUsersDataApi.endpoints.getConnectedUsersDataApi
        .matchFulfilled,
      (state, action) => {
        state.connectedWabaAccounts = action.payload;
      }
    );
  },
});

export const {
  clearConnectedWabaAccounts,
  updateOpenDrawer,
  updateGuestDetails,
  updateTeamMemberDrawer,
} = wahaSlice.actions;

// Selectors
export const getWahaState = (rootState: RootState): WahaState =>
  rootState[WAHA_FEATURE_KEY];

export const getAllConnectedWabaAccounts = createSelector(
  getWahaState,
  (state) => state.connectedWabaAccounts
);
export const selectDrawer = createSelector(
  getWahaState,
  (state) => state.drawer
);

export const getGuestDetails = createSelector(
  getWahaState,
  (state) => state.guestDetails
);

export const getTeamMemberDrawer = createSelector(
  getWahaState,
  (state) => state.teamMemberDrawer
);
